import type { FunctionComponent } from 'react'
import React from 'react'
import { Grid, GridItem } from '@which/seatbelt'

import type { BrandCampaignContentItem, SharingData } from '../../../../generated/frontend'
import { ComponentWrapper } from '../../../../shared/components/ComponentWrapper'
import styles from './BrandCampaignSections.module.scss'

export const BrandCampaignSections: FunctionComponent<Props> = ({
  contentItems,
  sharingData = null,
}) => {
  if (!contentItems.length) {
    return null
  }

  return (
    <GridItem span={{ medium: 12, large: 12 }} columnStart={{ medium: 1, large: 1 }}>
      {contentItems.map(({ type, data }, index) => {
        const Component = componentMapper[type]

        if (Component) {
          const { fullWidthBackgroundColour, backgroundColour } = data?.customData?.data

          const bgColor = backgroundColour || ''

          return (
            <Grid
              key={`grid-section-${index}`}
              includeGutters={false}
              className={styles.brandCampaignSection}
              style={!fullWidthBackgroundColour ? { backgroundColor: bgColor } : {}}
            >
              <Component {...data} key={`${type}-${index}`} sharingData={sharingData} />

              {fullWidthBackgroundColour && (
                <div
                  className={styles.brandCampaignSectionBackground}
                  style={{ backgroundColor: bgColor }}
                ></div>
              )}
            </Grid>
          )
        }
        // return null once brand campaign page is complete
        return (
          <div key={`notype-${index}`}>
            Data not mapped for component {type} ~ BrandCampaignSections
          </div>
        )
      })}
    </GridItem>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  contentItems: BrandCampaignContentItem[]
  sharingData?: SharingData
}

const componentMapper: Record<string, FunctionComponent<any>> = {
  ['component-wrapper']: ComponentWrapper,
}
